<template>
  <section>
    <el-col :span="6" class="toolbar">
      <el-input placeholder="" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
                    <el-table-column
        label="用户ID"
        prop="usid"
        align="center">
      </el-table-column>
      <el-table-column
        label="用户名称"
        prop="username"
        align="center">
      </el-table-column>

      <el-table-column
        label="文案内容"
        prop="writecontent"
        align="center">
      </el-table-column>
         <el-table-column
        label="链接"
        prop="schemeurl"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createtime"
        align="center">
      </el-table-column>
      <el-table-column
        label="修改时间"
        prop="updatetime"
        align="center">
      </el-table-column>
      <el-table-column
        label="推荐状态"
        prop="isrecommend"
        align="center">
        <template scope="scope">
          <div>{{recommend[scope.row.isrecommend]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="审核状态"
        prop="isverify"
        align="center">
        <template scope="scope">
          <div>{{verify[scope.row.isverify]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="记录状态"
        align="center">
        <template scope="scope">
          <div>{{status[scope.row.status]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center">
        <template scope="scope">
          <el-button v-if="scope.row.isverify != 0" type="primary"  size="small" @click="setVerify(scope.row._id)">审核</el-button>
          <el-button v-if="scope.row.isrecommend == 0"  type="danger" size="small" @click="setRecommend(scope.row._id, 1)">推荐</el-button>
          <el-button v-else  type="info" size="small" @click="setRecommend(scope.row._id, 0)">取消推荐</el-button>
            <el-button  type="info" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button v-if="scope.row.pic" type="info" size="small" @click="getPicUrl(scope.row)">查看图片</el-button>
          <el-button  v-if="scope.row.status == 0" type="info" size="small" @click="deleteData(scope.row._id)">删除记录</el-button>
           <el-button v-else  type="info" size="small" @click="recoveryData(scope.row._id)">恢复记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <el-dialog title="查看图片" v-model="picVisible">
      <div class="piclist">
        <a v-for="(pic, index) in picList" :key="index" target="_blank" :href="pic"><img :src="pic" /></a>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
        <el-form-item label="链接" prop="schemeurl">
          <el-input v-model="editForm.schemeurl" auto-complete="off" size="small" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:30,
        listLoading: false,
        expands: [],
        getRowKeys(row) {
          return row._id;
        },
        editForm: {},
        query: '',
        recommend: basicdata.recommend,
        verify: basicdata.verify,
        status: basicdata.status,
        picVisible: false,
        editFormVisible: false,
        picList: [],
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        let url = config.api_url + '/copywrite/page'
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
  		//操作删除
  		deleteData(id){
        if(id !=0){
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/copywrite/delete/' + id
          ).then(response => {
              if(response.data.state) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error)
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
            //操作恢复
      recoveryData(id){
        if(id !=0){
          this.$confirm('是否恢复?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/copywrite/recovery/' + id
          ).then(response => {
              if(response.data.state) {
                this.$message({
                  message: '成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error)
              this.$message({
                message: '异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //审核
      setVerify(id) {
        this.$axios.post(config.api_url + '/copywrite/verify', {
          id: id,
          status: 0
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '审核成功!',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '推荐失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '审核异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //推荐
      setRecommend(id, isrecommend) {
        this.$axios.post(config.api_url + '/copywrite/recommend', {
          id: id,
          status: isrecommend
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '推荐成功!',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '推荐失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '推荐异常，请联系管理员',
            type: 'error'
          });
        });
      },
    editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              //异步请求
              this.$axios.put(config.api_url + '/copywrite/schemeurl', {
                  id: para._id,
                  schemeurl: para.schemeurl
                }).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
       showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
      },
      //查看图片
      getPicUrl(row) {
        this.picVisible = true;
        this.picList = row.pic.split(',');
     }
     },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
    .rightsearch{
        float: right;
    }
    .piclist {
      width: 100%;
    }
    .piclist>a {
      width: 30%;
      float: left;
      padding: 0 10px 10px 10px;
    }
    .piclist>a>img {
     width: 100%;
     height: 100px;
    }
</style>


// WEBPACK FOOTER //
// writecopy.vue?44bbcc04